import React from 'react';
import { Shield, Lock, EyeOff } from 'lucide-react';
export function PrivacySection() {
  return <section className="py-24 bg-teal-900 text-white" data-id="element-105">
      <div className="container mx-auto px-4" data-id="element-106">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-107">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-108">
            Your health data stays yours
          </h2>
          <p className="text-lg text-teal-100" data-id="element-109">
            We believe privacy is a fundamental right, especially when it comes
            to your body.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-110">
          <div className="flex flex-col items-center text-center p-6" data-id="element-111">
            <div className="h-16 w-16 bg-teal-800 rounded-full flex items-center justify-center mb-6" data-id="element-112">
              <Shield className="h-8 w-8 text-teal-300" data-id="element-113" />
            </div>
            <h3 className="text-xl font-semibold mb-3" data-id="element-114">Privacy First</h3>
            <p className="text-teal-100/80 leading-relaxed" data-id="element-115">
              We only access the data you explicitly consent to share. You can
              revoke access at any time.
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-6" data-id="element-116">
            <div className="h-16 w-16 bg-teal-800 rounded-full flex items-center justify-center mb-6" data-id="element-117">
              <EyeOff className="h-8 w-8 text-teal-300" data-id="element-118" />
            </div>
            <h3 className="text-xl font-semibold mb-3" data-id="element-119">Read-Only Access</h3>
            <p className="text-teal-100/80 leading-relaxed" data-id="element-120">
              Vytaniq reads your data to generate insights but never modifies or
              deletes your history.
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-6" data-id="element-121">
            <div className="h-16 w-16 bg-teal-800 rounded-full flex items-center justify-center mb-6" data-id="element-122">
              <Lock className="h-8 w-8 text-teal-300" data-id="element-123" />
            </div>
            <h3 className="text-xl font-semibold mb-3" data-id="element-124">No Data Selling</h3>
            <p className="text-teal-100/80 leading-relaxed" data-id="element-125">
              Your health data is never sold to advertisers, insurance
              companies, or third parties. Period.
            </p>
          </div>
        </div>
      </div>
    </section>;
}